module.exports = __webpack_public_path__ + "img/logo.41b1e59c.png";